import { cn } from "@/lib/utils";

/**
 * Cor da parte "estoque restante" por faixa (PDF 08/10/2026, pág. 9):
 * 100% vermelho (nada vendido) → laranja → amarelo → 0% (tudo verde, estoque acabou).
 */
export const stockLevelColor = (percent: number) => {
  if (percent >= 100) return "#EF4444"; // vermelho
  if (percent > 50) return "#F59A33"; // laranja (até 70%)
  if (percent > 30) return "#F5AE3D"; // laranja-claro (até 50%)
  if (percent > 15) return "#F4BE44"; // amarelo-escuro (até 30%)
  return "#F3CF46"; // amarelo (até 15%)
};

const SOLD_COLOR = "#34C77B";

interface StockLevelBarProps {
  /** % de estoque disponível (0–100); null = sem base de cálculo */
  percent: number | null | undefined;
  className?: string;
  /** Texto do title (tooltip) */
  title?: string;
}

/**
 * Barra de % de estoque disponível (LOT-26): parte colorida = estoque restante, verde = vendido.
 */
export const StockLevelBar = ({ percent, className, title }: StockLevelBarProps) => {
  if (percent === null || percent === undefined) return null;

  const value = Math.max(0, Math.min(100, percent));
  const label = `${Number.isInteger(value) ? value : value.toFixed(1).replace(".", ",")}%`;

  return (
    <div className={cn("mx-auto mt-1 w-28", className)} title={title ?? `${label} do estoque disponível`}>
      <div
        className="flex h-2 w-full overflow-hidden rounded-full"
        style={{ backgroundColor: SOLD_COLOR }}
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Estoque disponível"
      >
        <div className="h-full rounded-full" style={{ width: `${value}%`, backgroundColor: stockLevelColor(value) }} />
      </div>
      <p className="mt-0.5 text-center text-[10px] font-medium leading-none text-gray-600 dark:text-gray-300">
        {label}
      </p>
    </div>
  );
};
